import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.one-trust-overlay',
        updateConsent: '.one-trust-overlay__update-consent',
        openCenter: '#cookie-center',
    },
    dataAttributes: {
        url: 'url',
    },
    classNames: {
        visible: 'one-trust-overlay--visible',
        clickable: 'one-trust-overlay--clickable',
    },
};

class OneTrustOverlay {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        this._elements = this._getDomElements();

        if(window.location.hostname === 'localhost') {
            this._$rootElement.removeClass(config.classNames.clickable); 
        }

        window.addEventListener('OneTrustInit', () => {
            if(typeof OneTrust === 'object') {
                if (!OnetrustActiveGroups.split(',').includes('C0003')) {
                    this._$rootElement.addClass(config.classNames.visible);
                    this._$rootElement.addClass(config.classNames.clickable);
                } else {
                    this._$rootElement.removeClass(config.classNames.visible);
                    this._$rootElement.removeClass(config.classNames.clickable);
                }
            } else {
                if(window.location.hostname === 'localhost') {
                    this._$rootElement.addClass(config.classNames.visible); 
                }
            }
        });

        this._elements.$updateConsent.on('click', () => {
            if(window.location.hostname === 'localhost') {
                this._$rootElement.removeClass(config.classNames.visible);
                this._$rootElement.removeClass(config.classNames.clickable);
                window.dispatchEvent(new CustomEvent('LocationMapInit', { detail: {} }));
                window.dispatchEvent(new CustomEvent('InteractiveLauncherInit', { detail: {} }));
            } else if(typeof OneTrust === 'object') {
                if($('#onetrust-banner-sdk').length === 0) {
                    $('body').append('<div id="onetrust-banner-sdk">');
                }
                OneTrust.UpdateConsent("Category","C0003:1"); 
            }
        });
    }

    _getDomElements() {
        return {
            $updateConsent: this._$rootElement.find(config.selectors.updateConsent),
            $openCenter: $(config.selectors.openCenter),
        };
    }
}

moduleRegistry.registerModule('OneTrustOverlay', OneTrustOverlay);
moduleRegistry.autoApplyModule('OneTrustOverlay', config.selectors.root);